/**
 * jQuery.mmenu off-canvas navigation
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/* global App, $ */

'use strict'

import forEach from '../../utils/forEach'

export default class OffCanvasNew {
  constructor (menuId) {
    this.menuId = menuId
    this.$menu = $(this.menuId)

    $(() => this.init())

    App.dispatcher.listen('off-canvas-new.open', () => {
      this.open()

      forEach(document.querySelectorAll('*[data-role="off-canvas-new.open"]'), (i, el) => {
        el.classList.add('icon-menu')
        el.classList.remove('icon-close')
      })
    })

    App.dispatcher.listen('off-canvas-new.close', () => {
      this.close()

      forEach(document.querySelectorAll('*[data-role="off-canvas-new.close"]'), (i, el) => {
        el.classList.add('icon-close')
        el.classList.remove('icon-menu')
      })
    })

    App.dispatcher.listen('off-canvas-new.toggle', () => {
      this.toggle()

      forEach(document.querySelectorAll('*[data-role="off-canvas-new.toggle"]'), (i, el) => {
        if (el.classList.contains('icon-close')) {
          el.classList.add('icon-menu')
          el.classList.remove('icon-close')
        } else {
          el.classList.add('icon-close')
          el.classList.remove('icon-menu')
        }
      })
    })
  }

  init () {
    this.$menu.mmenu({
      // options
      extensions: [
        'pagedim-black',
        'fx-menu-slide',
        'theme-white',
        'fx-listitems-slide'
      ],
      navbar: {
        title: 'Menu'
      },
      navbars: [{
        height: 3
      }, {
        content: ['prev', 'title', 'next']
      }],
      offCanvas: {
        pageNodetype: '#app',
        wrapPageIfNeeded: false
      }
    })

    this.api = this.$menu.data('mmenu')

    this.api.bind('close:finish', () => {
      forEach(document.querySelectorAll('*[data-role="off-canvas-new.toggle"]'), (i, el) => {
        el.classList.add('icon-menu')
        el.classList.remove('icon-close')
      })
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas-new.open"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas-new.open'), false)
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas-new.close"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas-new.close'), false)
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas-new.toggle"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas-new.toggle'), false)
    })
  }

  open () {
    this.api.open()
  }

  close () {
    this.api.close()
  }

  toggle () {
    this.$menu.hasClass('mm-menu_opened') ? this.close() : this.open()
  }
}
